module.exports = __webpack_public_path__ + "img/thumb_02.5593678a.jpg";